import { Typography, TypographyVariant } from "@outschool/backpack";
import { getCategoryPillTitle } from "@outschool/text";
import { useTrackEvent } from "@outschool/ui-analytics";
import { TopicPill } from "@outschool/ui-components-website";
import {
  Carousel,
  Container,
  Link,
} from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

type JumpPillsCarouselParams = {
  title: string;
  pillsData: {
    name: string;
    path: string;
  }[];
  containerStyle?: object;
  titleVariant?: TypographyVariant;
};

export default function JumpPillsCarousel({
  title,
  pillsData,
  containerStyle = {},
  titleVariant = "h4",
}: JumpPillsCarouselParams) {
  const isMobile = useIsMobile();
  const trackEvent = useTrackEvent();

  return (
    <Container sx={containerStyle}>
      <Typography
        variant={titleVariant}
        sx={{
          fontWeight: "bold",
          fontSize: isMobile && 22,
        }}
      >
        {title}
      </Typography>
      <Carousel
        sx={{
          marginTop: 12,
          marginX: isMobile ? "-1em" : 0,
          "a:hover": { textDecoration: "none" },
        }}
        innerSx={{
          justifyContent: "flex-start",
          gap: "small",
          paddingLeft: isMobile ? "1em" : 0,
          paddingRight: isMobile ? "1em" : 0,
          paddingTop: "2px",
          paddingBottom: "2px",
        }}
      >
        {pillsData.map(({ name, path }: $TSFixMe, index: $TSFixMe) => (
          <Link
            key={path}
            to={path}
            trackingName="category_pills"
            trackingUniqueId={path}
            sharedProperties={{
              categoryPage: path,
              pillIdx: index,
            }}
          >
            <TopicPill
              key={index.toString()}
              onClick={() => {
                trackEvent("jump-pill-click", {
                  name,
                  title,
                  index,
                });
              }}
            >
              {getCategoryPillTitle(name)}
            </TopicPill>
          </Link>
        ))}
      </Carousel>
    </Container>
  );
}
